import { render, staticRenderFns } from "./EditNoteDialog.vue?vue&type=template&id=8476178a&scoped=true&"
import script from "./EditNoteDialog.vue?vue&type=script&lang=js&"
export * from "./EditNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8476178a",
  null
  
)

export default component.exports